import { AnalysisForm } from 'modules/Analysis';

export const AnalysisFormPage = () => <AnalysisForm />;
